import Rows from '@svs/ui/react/icons/Rows';
import type { ReactNode } from 'react';

import type { ExternalWagerSelectedSystemType } from '../../schema/wager/entry.js';

type ExternalLabelProps = {
  typeOfSystem: ExternalWagerSelectedSystemType;
  numberOfSystems: number;
};

/**
 * The external label component for the betslip, showing the type of system and the number of systems/rows.
 *
 * @param props input object
 * @param props.typeOfSystem selected system type
 * @param props.numberOfSystems number of bet systems
 * @returns div with system info
 */
export default function BetslipExternalLabel({ typeOfSystem, numberOfSystems }: ExternalLabelProps): ReactNode {
  const title = typeOfSystem === 'MSYS' ? 'M-system' : 'Rader';
  const ariaLabel =
    typeOfSystem === 'MSYS' ? `${title}, ${numberOfSystems} system` : `${title}, ${numberOfSystems} rader`;

  return (
    <div className="[grid-area:hedges]" aria-label={ariaLabel} aria-live="polite">
      <div aria-hidden className="grid auto-cols-max grid-flow-col items-center gap-x-[6px] text-nowrap">
        <span>{title}</span>
        <Rows className="h-[16px] w-[16px] lg:mr-[12px] lg:h-[20px] lg:w-[20px]" />
        <div className="font-bold">{numberOfSystems} st</div>
      </div>
    </div>
  );
}
